import { setUserToken } from "../_shared/services/authentication.service";
import { loadConfig, loadLicenses } from "../actions/utils";
import { loadBlackoutDates } from "../_shared/services/blackoutdates.service";
import { ACTIONS } from "../actions/reducers";

export default async (store) => {
  await setUserToken(store);
  const config = await loadConfig().catch(e => ({ }));

  loadLicenses();

  // Card #254 — the holiday / blackout calendar. Cached on window like the app
  // config, because antd's `disabledDate` predicate runs during render and
  // cannot await. Fetched after setUserToken so the request carries a token,
  // and .catch()'d inside loadBlackoutDates so a failure boots an EMPTY
  // calendar (blocks nothing) rather than blocking app startup.
  loadBlackoutDates();

  store.dispatch({ type: ACTIONS.SET_CONFIG, config: { ...config, location: window.location.origin } })
};
